<div class="steam-inventory-content">
  <ng-container *ngIf="steamItems$ | async as steamItems; else loading">
    <span>Кол-во предметов: {{steamItems.count}} | Закешировано: {{steamItems.cachedAt | date: 'dd.MM.yy HH:mm'}}</span>
    <mat-divider class="divider"></mat-divider>
    <div class="steam-inventory-container">
      <app-market-item *ngFor="let item of steamItems.items"
                       [name]="item.baseItem.shortName || item.baseItem.name"
                       [weapon]="item.baseItem.icon"
                       [price]="item.price"
                       [color]="item.baseItem.color"
                       [exterior]="item.baseItem.exterior"
                       [skin]="item.baseItem.skin"
                       [tradable]="item.tradable"
                       [statTrak]="item.baseItem.statTrak">
      </app-market-item>
    </div>
    <p *ngIf="!steamItems.items.length" class="empty-data">Предметов нет</p>
  </ng-container>
</div>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
